import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestService } from '../../shared/service/rest.service';
import { MacAddress } from '../model/mac-address';

@Injectable()
export class MacAddressService extends RestService {

  fetchMACAddresses(): Observable<MacAddress[]> {
    return this.postAndExtract<MacAddress>(MacAddress, 'api/fetch/macAssignments');
  }
}
